import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuestionOption } from '../components/Questionnaire';

interface SelectedAnswers {
  questionId: string;
  answers: QuestionOption[];
}

export interface AnswersState {
  selectedAnswers: SelectedAnswers[];
}

const initialState: AnswersState = {
  selectedAnswers: [],
};

export const answersSlice = createSlice({
  name: 'assessment',
  initialState,
  reducers: {
    updateAnswers: (state, action: PayloadAction<SelectedAnswers>) => {
      const alreadyExistingIndex = state.selectedAnswers.findIndex(
        (value) => value.questionId === action.payload.questionId,
      );

      if (alreadyExistingIndex >= 0) {
        state.selectedAnswers[alreadyExistingIndex] = action.payload;
        return;
      }

      state.selectedAnswers = [...state.selectedAnswers, action.payload];
    },
    resetAnswers: () => initialState,
  },
});

export const { updateAnswers, resetAnswers } = answersSlice.actions;

export default answersSlice.reducer;
